<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1200px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Uwagi jakościowe
                </h1>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container fluid class="px-6 py-2">
                    <v-data-table
                        :headers="headers"
                        :items="jobNotes"
                        no-data-text="Brak uwag jakościowych dla zlecenia"
                    >
                        <template #item.productionProcess="{item}">
                            {{ item.productionProcess.name }}
                        </template>
                        <template #item.code="{item}">
                            {{ item.code.name }}
                        </template>
                        <template #item.comment="{item}">
                            {{ item.comment }}
                        </template>
                        <template #item.reportedBy="{item}">
                            <template v-if="item.reportedBy.firstName && item.reportedBy.lastName">
                                {{ item.reportedBy.firstName }} {{ item.reportedBy.lastName }}
                            </template>
                            <template v-else>
                                {{ item.reportedBy.username }}
                            </template>
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-btn text color="info" @click="onClose">
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import dateFormatter from '@/mixins/dateFormatter'


export default {
    name: 'JobNotesListDialog',
    mixins:[
        dateFormatter,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        jobId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Proces',
                    value: 'productionProcess',
                    sortable: false,
                },
                {
                    text: 'Defekt',
                    value: 'code',
                    sortable: false,
                },
                {
                    text: 'Komentarz',
                    value: 'comment',
                    sortable: false,
                },
                {
                    text: 'Zgłaszający',
                    value: 'reportedBy',
                    sortable: false,
                },
                {
                    text: 'Data złożenia',
                    value: 'createdAt',
                    sortable: false,
                },
            ],
            jobNotes: [],
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.$store.dispatch('jobs/getJobNotes', this.jobId)
                    .then(response => {
                        this.jobNotes = response.data.results
                    })
            }
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        },
    },    
}
</script>